import { type RegisteredApp } from '~/shared/appContract'

import { SCOUT_APP_ID } from './paths'

/**
 * Scout's public entrypoint, and the only module anything outside Scout may import: the app registry
 * mounts Scout from it. It declares Scout's id, display name, switcher description, and the loaders
 * that fetch Scout's routes and its header nav (Atlas ADR-0017).
 *
 * Nothing here may import `ScoutRoutes`, the nav, or a page statically: this module lands in the entry
 * chunk (the registry reads every app's id and copy on first paint), so a static import would put them
 * there too. Scout's nav is the case that makes this matter rather than merely tidy — it queries
 * `/scout/gap-categories`, so it reaches Scout's generated client, which no user who cannot reach Scout
 * should download. Both `import()`s below go through `ScoutChunk` so that chunk is one rather than two.
 * See Atlas ADR-0019 and Atlas ADR-0021.
 *
 * The id comes from `SCOUT_APP_ID` rather than a literal, so the segment the shell mounts and the one
 * Scout's own links are built from cannot disagree. `paths.ts` is a safe static import here: it is
 * string building and imports nothing, so it costs the entry chunk nothing a literal would save.
 */
export const scoutApp: RegisteredApp = {
  id: SCOUT_APP_ID,
  name: 'Scout',
  description: 'Find and act on care gaps like procedures and consults',
  loadRoutes: () =>
    import('./ScoutChunk').then(({ ScoutRoutes }) => ({
      Component: ScoutRoutes,
    })),
  loadNav: () =>
    import('./ScoutChunk').then(({ ScoutNav }) => ({ Component: ScoutNav })),
}
